import { Button, ButtonGroup, styled } from '@mui/material';

export const AssemblyButtonGroup = styled(ButtonGroup)`
  display: flex;
`;

export const AssemblyButton = styled(Button)`
  flex: 1;
`;
